import React from 'react';
import HeritageGatewayCountyFilter from './filters/HeritageGatewayCountyFilter';
import HeritageGatewayDatasetFilter from './filters/HeritageGatewayDatasetFilter';
import HeritageGatewayLocalPlanningAuthority from './filters/HeritageGatewayLocalPlanningAuthorityFilter';
import HeritageGatewayLocalAuthority from './filters/HeritageGatewayLocalAuthorityFilter';
import HeritageGatewayParishFilter from './filters/HeritageGatewayParishFilter';
import HeritageGatewayParliamentaryConstituencyFilter from './filters/HeritageGatewayParliamentaryConstituencyFilter';
import HeritageGatewayProtectedStatusFilter from './filters/HeritageGatewayProtectedStatusFilter';
import HeritageGatewayDateRangeFilter from './filters/HeritageGatewayDateRangeFilter';
import HeritageGatewayFindsType from './filters/HeritageGatewayFindsType';
import HeritageGatewayFindsPeriod from './filters/HeritageGatewayFindsPeriod';
import HeritageGatewayFindsMaterials from './filters/HeritageGatewayFindsMaterials';
import HeritageGatewayMaritimeCraftType from './filters/HeritageGatewayMaritimeCraftType';
import HeritageGatewayMaritimeCraftPeriod from './filters/HeritageGatewayMaritimeCraftPeriod';
import HeritageGatewayMaritimeCraftMaterials from './filters/HeritageGatewayMaritimeCraftMaterials';
import HeritageGatewayAirCraftType from './filters/HeritageGatewayAirCraftType';
import HeritageGatewayAirCraftPeriod from './filters/HeritageGatewayAirCraftPeriod';
import HeritageGatewayAirCraftMaterials from './filters/HeritageGatewayAirCraftMaterials';
import HeritageGatewayMonumentTypeFilter from './filters/HeritageGatewayMonumentTypeFilter';
import HeritageGatewayMonumentPeriodFilter from './filters/HeritageGatewayMonumentPeriodFilter';
import HeritageGatewayMonumentMaterialsFilter from './filters/HeritageGatewayMonumentMaterialsFilter';
import HeritageGatewayMonumentEvidenceFilter from './filters/HeritageGatewayMonumentEvidenceFilter';
import FormGroup from '../../components/FormGroup';
import FormGroupWithBackground from '../../components/FormGroupWithBackground';

export default function HeritageGatewaySearchFilters() {
  return (
    <>
      <FormGroup noBorder title="Location">
        <HeritageGatewayLocalPlanningAuthority />
        <HeritageGatewayCountyFilter />
        <HeritageGatewayLocalAuthority />
        <HeritageGatewayParishFilter />
        <HeritageGatewayParliamentaryConstituencyFilter />
      </FormGroup>

      <FormGroup title="Dataset">
        <HeritageGatewayDatasetFilter />
      </FormGroup>

      <FormGroup title="Monument Type and Dates">
        <HeritageGatewayMonumentTypeFilter />
        <HeritageGatewayMonumentPeriodFilter />
        <HeritageGatewayDateRangeFilter />
        <HeritageGatewayMonumentMaterialsFilter />
        <HeritageGatewayMonumentEvidenceFilter />
        <HeritageGatewayProtectedStatusFilter />

        <FormGroupWithBackground title="Associated Finds">
          <HeritageGatewayFindsType />
          <HeritageGatewayFindsPeriod />
          <HeritageGatewayFindsMaterials />
        </FormGroupWithBackground>

        <FormGroupWithBackground title="Associated Maritime Craft">
          <HeritageGatewayMaritimeCraftType />
          <HeritageGatewayMaritimeCraftPeriod />
          <HeritageGatewayMaritimeCraftMaterials />
        </FormGroupWithBackground>

        <FormGroupWithBackground title="Associated Aircraft">
          <HeritageGatewayAirCraftType />
          <HeritageGatewayAirCraftPeriod />
          <HeritageGatewayAirCraftMaterials />
        </FormGroupWithBackground>
      </FormGroup>
    </>
  );
}
